import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { Grid, Button, Input, TextField } from "@mui/material";
import { useReactToPrint } from "react-to-print";
import Autocomplete from '@mui/material/Autocomplete';
import { ToastContainer, toast } from 'react-toastify';
import { IconButton } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const showDuplicateEntryAlert = () => {
  MySwal.fire({
    title: <strong>Duplicate Entry</strong>,
    html: <p>QcItCode is already present!</p>,
    icon: 'info',
    confirmButtonColor: '#1976d2', // Change this color as needed
    confirmButtonText: 'OK',
  });
};

function QualityCheckMaster(props) {
    const [QcCode, setQcCode] = useState(0); 
    const [QcItCode, setQcItCode] = useState(0); 
    const [PerQty, setPerQty] = useState(0.0); 
    const [Narration, setNarration] = useState(''); 
    const [rows, setRows] = useState([{ Parameter: '', StartValue: '', Endvalue: '' }]);
    const [DeptCode, setDeptCode] = useState('');
    const [UserID, setUserID] = useState('');
    const [units, setUnits] = useState([]);
    const [editFormulaNo, setEditFormulaNo] = useState(null);
    const [dialogOpen, setDialogOpen] = useState(false);

    const [deleteEntryNo, setDeleteEntryNo] = useState(null);
    const [openConfirmation, setOpenConfirmation] = useState(false);  
    const [formMode, setFormMode] = useState('add');
    const [editCasteId, setEditCasteCode] = useState(null);
    const [showGrid, setShowGrid] = useState(true);
    const [ProductMasterEntries, setProductMasterEntries] = useState([]);
    const [itemMasterEntries, setItemMasterEntries] = useState([]);

    useEffect(() => {
        fetchProductMaster();
        fetchItemMaster();
    }, []);

    const fetchProductMaster = async () => {
        try {
            const response = await axios.get('https://www.wingap.net.in/api/qualcheck');
            setProductMasterEntries(response.data);
            const maxEntryNo = calculateMaxEntryNo(response.data);
            const nextEntryNo = maxEntryNo + 1; 
            setQcCode(nextEntryNo);
            //console.log(response.data);
        } catch (error) {
            console.log('error:', error);
        }
    };


    const calculateMaxEntryNo = (entries) => {
        let maxEntryNo = 0;
        for (const entry of entries) {
            if (entry.QCCODE > maxEntryNo) {
                maxEntryNo = entry.QCCODE;
            }
        }
        return maxEntryNo;
    };

    const fetchItemMaster = async () => {
        try {
            const response = await axios.get("https://www.wingap.net.in/api/items-master");
            setItemMasterEntries(response.data.sort((a, b) => a.ItCode - b.ItCode));
        } catch (error) {
            console.log("error:", error);
        }
    };

    const addProduct = async () => {
        if ((!props.canAdd)) {
              const action = "Save";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
        try {
            const productData = {
                QCCode: Number(QcCode),
                QCItCode: Number(QcItCode),
                //UserID: props.name,
                items: rows, 
            };

            await axios.post('https://www.wingap.net.in/api/qualcheck', productData);
            toast.success('Quality Check Added Successfully....',{autoClose:650});
            setQcItCode(0);
            setRows([{ Parameter: '', StartValue: '', Endvalue: '' }]);
            fetchProductMaster(); 
        } catch (error) {
            console.log('Error:', error);
        }
    }; 


    const updateProduct = async () => {
        if ((!props.canEdit)) {
              const action = "Update";
              toast.error(`You do not have permission to ${action}.`, { autoClose: 780 });
              return;
            }
        try {
            const updatedProductData = {
                QCCode: Number(QcCode),
                QCItCode: Number(QcItCode),
                //UserID: props.name,
                items: rows, 
            };
            await axios.put(`https://www.wingap.net.in/api/qualcheck/${QcCode}`, updatedProductData);
            toast.success('Quality Check Updated Successfully....',{autoClose:650});
            resetForm();
            setFormMode('add');
            fetchProductMaster(); 
        } catch (error) {
            console.log('Error updating product:', error);
        }
    };

    const handleDeleteConfirmation = async () => {
        try {
          if (deleteEntryNo) {
            await deleteProduct(deleteEntryNo);
            setOpenConfirmation(false);
          }
        } catch (error) {
          console.log('Error:', error);
        }
      };

    const deleteProduct = async (QcCode) => {
        if (!props.canDelete) {
                  toast.error("You do not have permission to Delete.", { autoClose: 800 });
                  return;
                }
        try {
            await axios.delete(`https://www.wingap.net.in/api/qualcheck/${QcCode}`, {
                headers: {
                    'username': props.name,
                },
            });
            fetchProductMaster();
        } catch (error) {
            console.log('Error:', error);
        }
    };  

    const setEditForm = (room) => {
        console.log(room);
        setFormMode('edit'); 
        setQcCode(room.QCCODE);
        setQcItCode(room.QCITCODE);
        //setUserID(room.UserID);
    
        const filteredEntries = ProductMasterEntries.filter(entry => entry.QCCODE == room.QCCODE);

        const newRows = filteredEntries.map(filteredEntry => {
            return {
                Parameter: filteredEntry.Parameter,
                StartValue: filteredEntry.StdValue1,
                Endvalue: filteredEntry.StdValue2,
            };
        });
    
        setRows(newRows);
        setShowGrid(false);
    };

    const handleSaveProduct = async () => {
        if (formMode === 'add') {
            await addProduct();
        } else if (formMode === 'edit') {
            await updateProduct();
        }
    };    
    
    const resetForm = () => {
        setQcItCode(0);
        setPerQty(0.0);
        setNarration('');
        setRows([{ RawItCode: 0, Qty: 0.0, PerKg: '' }]);
    };    

    const handleshowandhide = () => {
        setFormMode('add');
        setShowGrid(!showGrid);
        setUnits(units);
        setQcItCode('');
        setPerQty('');
        setNarration('');
        fetchProductMaster();
        setRows([{ Parameter: '', StartValue: '', Endvalue: '' }]); 
    };

    const handleCancel = () => {
        setFormMode('add');
        setEditCasteCode('');
        setPerQty('');
        setNarration('');
        /* setQty('');
        setPerKg('');
        setRawItCode(''); */
        setUserID('');
        fetchProductMaster();
    };

    const componentPDF = useRef();

    const generatePDF = useReactToPrint({
        content: () => componentPDF.current,
        documentTitle: "Caste Data",
        onAfterPrint: () => alert("Pdf downloaded"),
        pageStyle: `
      @media print {
        .print-hide {
          display: none;
        }

        table th.print-hide,
        table td.print-hide {
          border: none;
        }
      }
    `,
    });

    const handleDialogClose = () => {
        setDialogOpen(false);
    };

    const handleRowChange = (index, field, value) => {
        const updatedRows = rows.map((row, i) => {
            if (i === index) {
                return { ...row, [field]: value }; 
            }
            return row;
        });
        setRows(updatedRows);
    };

    const addRow = () => {
        setRows([...rows, { Parameter: '', StartValue: '', Endvalue: '' }]); 
    };

    const removeRow = (index) => {
        const newRows = rows.filter((_, i) => i !== index);
        setRows(newRows);
    };

    return (
        <div style={{ maxWidth: '100%', margin: '0 auto', padding: '20px' }}>
            <ToastContainer/>
            <h1 style={{ fontSize: '24px', marginBottom: '10px' }}>Quality Check Master</h1>
            <Grid item>
                {(props.canAdd === true) && (<Button
                    variant="contained"
                    className="view-button"
                    onClick={handleshowandhide}
                    sx={{ backgroundColor: showGrid ? '#4caf50' : 'blue', color: "white", marginBottom: "20px", float: 'right' }}
                >
                    {showGrid ? 'Add' : 'Back'}
                </Button>)}
            </Grid>
            {showGrid && <Grid item>
                <Button
                    variant="contained"
                    onClick={generatePDF}
                    sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
                >
                    Download PDF
                </Button>
            </Grid>}
            {showGrid && <Grid item>
                <Button
                    variant="contained"
                    sx={{ backgroundColor: "yellow", color: "black", marginBottom: "20px", float: 'right', marginRight: "10px" }}
                >
                    Export
                </Button>
            </Grid>}
            {!showGrid && (
                <>
                    <h2 style={{ fontSize: '20px', marginBottom: '10px' }}>
                        {formMode === 'add' ? 'Add' : 'Edit'}
                    </h2>
                    <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '10px' }}>
                        <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                            <label htmlFor="QcCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>
                                QcCode
                            </label>
                            <input
                                type="number"
                                value={QcCode}
                                //onChange={(e) => setPerQty(e.target.value)}
                                readOnly
                                placeholder="QcCode"
                                style={{ marginBottom: '5px', padding: '5px', width: '100px' }}
                            />
                        </div>
                        <div style={{ display: 'flex', marginBottom: '5px', alignItems: 'center' }}>
                            <label htmlFor="QcItCode" style={{ width: '150px', marginRight: '10px', fontSize: '16px' }}>QcItCode</label>
                            <Autocomplete
                                options={itemMasterEntries}
                                getOptionLabel={(option) => option.ItName || ''}
                                value={itemMasterEntries.find((item) => item.ItCode == QcItCode) || null}
                                onChange={(event, newValue) => {
                                    if (newValue) {
                                        setQcItCode(newValue.ItCode);
                                    } else {
                                        setQcItCode('');
                                    }
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        placeholder="Quality Item Name "
                                        sx={{
                                            marginBottom: '5px',
                                            width: '100%',
                                            '& .MuiInputBase-input': {
                                                color: 'black',
                                                padding: '1px',
                                                height:'2px'
                                            },
                                            '& .MuiInputLabel-root': {
                                                color: 'black',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                borderColor: 'black',
                                            },
                                            '& .MuiSvgIcon-root': {
                                                color: 'black',
                                            },
                                            backgroundColor: 'white'
                                        }}
                                    />
                                )}
                                sx={{ width: '30%' }}
                                isOptionEqualToValue={(option, value) => option.ItCode === value.ItCode}
                            />
                        </div>

                        <div style={{
                            overflow: 'auto',
                            maxHeight: '380px',
                            width: '80%',
                            margin: '8px auto',
                            padding: '8px',
                            borderRadius: '5px',
                            boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)'
                        }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                border: '1px solid #333',
                                tableLayout: 'fixed'
                            }}>
                                <thead style={{ backgroundColor: 'gray', position: 'sticky', top: 0, zIndex: 10 }}>
                                    <tr>
                                        <th style={{ width: '70px', border: '1px solid #333', padding: '6px', textAlign: 'left' }}>SrNo.</th>
                                        <th style={{ border: '1px solid #333', padding: '6px', textAlign: 'left' }}>Parameter</th>
                                        <th style={{ border: '1px solid #333', padding: '6px', textAlign: 'left' }}>StartValue</th>
                                        <th style={{ border: '1px solid #333', padding: '6px', textAlign: 'left' }}>EndValue</th>
                                        <th style={{ width:'120px', border: '1px solid #333', padding: '6px', textAlign: 'center' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ width: '70px', border: '1px solid #333', padding: '6px', textAlign:'center' }}>{index + 1}</td>
                                            <td style={{ border: '1px solid #333', padding: '6px' }}>
                                                <input
                                                    type="text"
                                                    value={row.Parameter}
                                                    onChange={(e) => handleRowChange(index, 'Parameter', e.target.value)}
                                                    placeholder="Parameter"
                                                    style={{ padding: '5px', width: '100%', border:'none' }}
                                                /> 
                                            </td>
                                            <td style={{ border: '1px solid #333', padding: '6px' }}>
                                                <input
                                                    type="text"
                                                    value={row.StartValue}
                                                    onChange={(e) => handleRowChange(index, 'StartValue', e.target.value)}
                                                    placeholder="StartValue"
                                                    style={{ padding: '5px', width: '100%', border:'none' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid #333', padding: '6px' }}>
                                                <input
                                                    type="text"
                                                    value={row.Endvalue}
                                                    onChange={(e) => handleRowChange(index, 'Endvalue', e.target.value)}
                                                    placeholder="Endvalue"
                                                    style={{ padding: '5px', width: '100%', border:'none' }}
                                                />
                                            </td>
                                            <td style={{ border: '1px solid #333', padding: '6px', textAlign: 'center',width:'120px' }}>
                                                <IconButton onClick={() => removeRow(index)} aria-label="delete">
                                                    <DeleteIcon sx={{color:'red'}}/>
                                                </IconButton>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr style={{
                                        position: 'sticky',
                                        bottom: 0,
                                        zIndex: 11,
                                        backgroundColor: '#f1f1f1'
                                    }}>
                                        <td colSpan={4} style={{ textAlign: "left", padding: "2px", border: "1px solid #333" }}>
                                            <button
                                                onClick={addRow}
                                                style={{
                                                    backgroundColor: "white",
                                                    color: "black",
                                                    padding: "4px 12px",
                                                    border: "none",
                                                    borderRadius: "4px",
                                                    cursor: "pointer",
                                                    fontSize: "14px",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "5px",
                                                }}
                                            >
                                                ➕ Add Row
                                            </button>
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                            {/* <Dialog
                                open={dialogOpen}
                                onClose={handleDialogClose}
                                aria-labelledby="alert-dialog-title"
                                aria-describedby="alert-dialog-description"
                            >
                                <DialogTitle
                                    id="alert-dialog-title"
                                    sx={{ display: 'flex', alignItems: 'center', gap: 1, color: blue[800] }}
                                >
                                    <InfoIcon sx={{ color: blue[800] }} /> Duplicate Entry
                                </DialogTitle>
                                <DialogContent id="alert-dialog-description" sx={{ color: 'black', fontWeight: 'bold',fontSize:'16px' }}>
                                    <p>QcItCode is already present!</p>
                                </DialogContent>
                                <DialogActions>
                                    <Button onClick={handleDialogClose} color="primary" autoFocus>
                                        OK
                                    </Button>
                                </DialogActions>
                            </Dialog> */}
                        {/* <button
                            type="button"
                            onClick={addRow}
                            style={{
                                padding: '10px 20px',
                                width: '120px',
                                marginTop: '10px',
                                marginRight:'20px',
                                // backgroundColor: '#58e8c4',
                                backgroundColor: 'gray',
                                color: 'white',
                                border: 'none',
                                borderRadius: '5px',
                                cursor: 'pointer',
                                position:'sticky',
                                bottom:0
                            }}
                        >
                            Add Row
                        </button> */}
                        </div>
                    </div>

                    <div>
                        <button
                            className={formMode === 'add' ? 'add-button' : 'update-button'}
                            onClick={handleSaveProduct}
                            style={{
                                padding: '10px 20px',
                                fontSize: '16px',
                                backgroundColor: formMode === 'add' ? '#4caf50' : '#2196f3',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                marginBottom: '10px', borderRadius:'5px'
                            }}
                        >
                            {formMode === 'add' ? 'Add' : 'Update'}
                        </button>
                        <button
                            className="view-button"
                            onClick={handleCancel}
                            style={{
                                padding: '10px 20px',
                                fontSize: '16px',
                                backgroundColor: '#f44336',
                                color: 'white',
                                border: 'none',
                                cursor: 'pointer',
                                marginLeft: '10px',
                                marginBottom: '10px', borderRadius:'5px'
                            }}
                        >
                            Cancel
                        </button>
                    </div>

                </>
            )}
            {showGrid && (
                <div ref={componentPDF} style={{ width: '100%' }}>
                    <h2>Entries</h2>
                    <table
                        style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            border: '1px solid #ccc',
                        }}
                    >
                        <thead>
                            <tr style={{ background: '#f2f2f2', color: 'black' }}>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    SrNo.
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    QcCode
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                >
                                    QcItCode
                                </th>
                                <th
                                    style={{
                                        padding: '6px',
                                        background: '#f2f2f2',
                                        border: '1px solid #ccc',
                                    }}
                                    className="print-hide"
                                >
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {ProductMasterEntries.reduce((accumulator, current) => {
                                const x = accumulator.find(item => item.QCCODE === current.QCCODE);
                                if (!x) {
                                    return accumulator.concat([current]);
                                } else {
                                    return accumulator;
                                }
                                
                            }, []).map((caste, index) => {
                                const selectedGroup = itemMasterEntries.find(group => group.ItCode == caste.QCITCODE);
                                return(
                                <tr key={caste.QCCODE} style={{ backgroundColor: 'white', color: 'black', textAlign: 'center' }}>
                                    <td style={{ padding: '6px', border: '1px solid #ccc' }}>{index + 1} </td>
                                    <td style={{ padding: '6px', border: '1px solid #ccc' }}>{caste.QCCODE}</td>
                                    <td style={{ padding: '6px', border: '1px solid #ccc' }}>{selectedGroup ? `${selectedGroup.ItName}` : ''} </td>

                                    <td className="print-hide">
                                        {(props.canEdit === true) && (<button
                                            className='action-btn btn-edit'
                                            onClick={() => setEditForm(caste)}
                                        >
                                            Edit
                                        </button>)}
                                        {(props.canDelete === true) && (<button
                                            className='action-btn btn-delete'
                                            //onClick={() => deleteProduct(caste.QcCode)}
                                            onClick={() => {
                                                setDeleteEntryNo(caste.QCCODE);
                                                setOpenConfirmation(true);
                                              }}
                                        >
                                            Delete
                                        </button>)}
                                    </td>
                                </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}
            {<Dialog
            open={openConfirmation}
            onClose={() => setOpenConfirmation(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">{"CONFIRM DELETE"}</DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                Are you sure you want to DELETE this Entry ?
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setOpenConfirmation(false)} color="inherit">
                Cancel
              </Button>
              <Button onClick={() => handleDeleteConfirmation()} color="error" autoFocus>
                Confirm
              </Button>
            </DialogActions>
          </Dialog>} 
        </div>
    );
}
export default QualityCheckMaster;